import { object } from "../../helpers/object";
import { debug } from "../../helpers/debug";
import { mask } from "../../components/mask";
import { utils } from "../../helpers/utils";
import { importLib } from "../../helpers/async-libs";

/*------------------------------------*\
  #PRODUCT-VIEWER

  Gestion de fake product-viewer pour des raison SEO

  [data-js-product-viewer-selected] // DOM_element affichage du name de la current viewer
  [data-js-trigger="product-viewer-select"] // trigger de selection
  [data-js-product-viewer-name="{string}"] // name de la viewer
  [aria-current="{bool}"] // etat de selection
\*------------------------------------*/
class ProductViewer {

  constructor(module){
    this.MODULE = module;
    this.DOM_MODULE = object.toArray(document.querySelectorAll(this.MODULE));
  }
  /**
   * INITIALISATION
   * @returns 
   */
  init = () => {
    if (!this.DOM_MODULE.length) return;
    // DEFAULT EVENT
    document.addEventListener('click', this.clickHandler);
    // document.addEventListener('mousedown', this.mousedownHandler);

    if(debug.DEBUG) console.log('async/product/viewer.js');
  };

  /**
   * CLICK HANDLER
   * 
   * Gestionnaire des event de la barre de navigation
   * @param {event} event 
   * @returns 
   */
  clickHandler = (event) => {
    if (event.target.matches('[data-js-trigger="product-viewer-thumbnail-select"]')) {
      if (event.target.matches('[aria-current="false"]')) {
        const target = event.target.getAttribute('aria-controls');
        this.currentDisable();
        this.currentSelect(target);
      }
      if (event.target.matches('[data-js-product-viewer-type="video"]')) {
        importLib('video.js').then((video) => {
          video.stopOthers();
        });
      }
    } else if (event.target.matches('[data-js-trigger="viewer-zoom"]')) {
      this.zoomHandler(event.target);
    }
  }
  /**
   * Handles the zoom functionality for a given element.
   * 
   * @param {HTMLElement} element - The DOM element to which zoom functionality will be applied.
   * 
   * @description
   * This function sets up event listeners for mouse and touch events to enable zooming on the specified element.
   * It also sets attributes to indicate the loading and enabling of the zoom feature.
   * 
   * Events:
   * - 'mousemove': Triggers the zoomMove function to handle zooming on mouse move.
   * - 'touchmove': Triggers the zoomMove function to handle zooming on touch move.
   * - 'mouseout': Resets the zoom when the mouse leaves the element.
   * - 'touchend': Resets the zoom when the touch ends.
   * 
   * Attributes:
   * - 'data-js-viewer-zoom-loading': Set to true when zoom is being initialized.
   * - 'data-js-viewer-zoom-enabled': Set to true after a delay to indicate that zoom is enabled.
   */
  zoomHandler = (element) => {
    element.setAttribute('data-js-viewer-zoom-loading', true);
    element.addEventListener('mousemove', (e) => {
      this.zoomMove(e, element);
    });
    element.addEventListener('touchmove', (e) => {
      this.zoomMove(e, element);
    });
    element.addEventListener('mouseout', () => {
      this.zoomReset(element);
    });
    element.addEventListener('touchend', () => {
      this.zoomReset(element);
    });
    setTimeout(() => {
      element.setAttribute('data-js-viewer-zoom-enabled', true);
    }, 500);
  }
  /**
   * Resets the zoom state of the given element.
   *
   * @param {HTMLElement} element - The DOM element to reset the zoom state for.
   */
  zoomReset = (element) => {
    element.setAttribute('data-js-viewer-zoom-enabled', false);
    element.setAttribute('data-js-viewer-zoom-loading', false);
    mask.display = false;
  }

  /**
   * Handles the zoom movement on an element.
   *
   * @param {MouseEvent | TouchEvent} e - The event object, which can be a mouse or touch event.
   * @param {HTMLElement} element - The HTML element on which the zoom effect is applied.
   */
  zoomMove = (e, element) => {
      const rect = element.getBoundingClientRect();
      let x = e.clientX - rect.left;
      let y = e.clientY - rect.top;
      if (e.type === 'touchmove') {
          const touch = e.touches[0];
          x = touch.clientX - rect.left;
          y = touch.clientY - rect.top;
          mask.display = 'overflow';
      }

      
      const zoomLens = element.querySelector('.js-image-zoom-target');
      if (zoomLens.matches('[data-js-image-zoom-src-zoom]') && zoomLens.src !== zoomLens.getAttribute('data-js-image-zoom-src-zoom')) {
        const zoomSrc = zoomLens.getAttribute('data-js-image-zoom-src-zoom');
        zoomLens.src = zoomSrc;
      }
      if (zoomLens) {
        const zoomFactor = 1.5;
        const zoomLensWidth = zoomLens.offsetWidth * zoomFactor;
        const zoomLensHeight = zoomLens.offsetHeight * zoomFactor;

        const offsetX = (x / rect.width) * zoomLensWidth - zoomLensWidth / 2;
        const offsetY = (y / rect.height) * zoomLensHeight - zoomLensHeight / 2;

        const zoomOffsetX = -(offsetX * 100 / rect.width) * zoomFactor;
        const zoomOffsetY = -(offsetY * 100 / rect.height) * zoomFactor;

        element.style.setProperty('--viewer-zoom-x', `${zoomOffsetX}px`);
        element.style.setProperty('--viewer-zoom-y', `${zoomOffsetY}px`);
        element.style.setProperty('--viewer-zoom-factor', `${zoomFactor}`);
      }
  }
  /**
   * CURRENT DESELECT
   * 
   * Désélection de la variation en cours
   * 
   * @returns 
   */
  currentDisable = () => {
    const thumbnail = this.DOM_MODULE[0].querySelector('.c-product-viewer__thumbnail[aria-current="true"]');
    const image = this.DOM_MODULE[0].querySelector('.c-product-viewer__image[aria-current="true"]');
    if (image) {
      const zoom = image.querySelector('.c-product-viewer__zoom');
      if (zoom) zoom.setAttribute('tabindex', -1);
    }
    if (!thumbnail || !image) return;
    thumbnail.setAttribute('aria-current', false);
    image.setAttribute('aria-current', false);
  }
  /**
   * CURRENT SELECT
   * 
   * selection de la variation
   * 
   * @param {string} target 
   * @returns 
   */
  currentSelect = (target) => {
    const thumbnail = this.DOM_MODULE[0].querySelector(`.c-product-viewer__thumbnail[aria-controls="${target}"]`);
    const imageWrapper = this.DOM_MODULE[0].querySelector(`.c-product-viewer__image#${target}`);
    const image = imageWrapper.querySelector('[data-js-img-src]');

    if (image) {
      utils.imgGenerator(image).then(() => {
        this.viewerImagesHeight = imageWrapper.offsetHeight;
      });
    }

    if (imageWrapper) {
      const zoom = imageWrapper.querySelector('.c-product-viewer__zoom');
      if (zoom) zoom.removeAttribute('tabindex');
    }
    this.viewerImagesHeight = imageWrapper.offsetHeight;
    
    if (thumbnail) thumbnail.setAttribute('aria-current', true);
    if (imageWrapper) imageWrapper.setAttribute('aria-current', true);
  }

  set viewerImagesHeight (height) {
    this.DOM_MODULE[0].style = `--viewer-images-height: ${height}px`;
  }
}
export default new ProductViewer('[data-js-component="product-viewer"]');